export const sharedNextPage = (page, params, history) => {
    try {
        // console.log('sharedNextPage');
        // console.log(sharedNextPage);
        // console.log('params');
        // console.log(params);
        // debugger;
        if (params !== undefined && params !== null) {
            if (params.acciones !== undefined) {
                delete params.acciones;
            }
            // console.log('params sin acciones');
            // console.log(params);
            history.push({
                pathname: `${page}`,
                state: params
            });
        } else {
            history.push(`${page}`);
        }
    } catch (err) {
        console.log('sharedNextPage err');
        console.log(err);
    }
};

export const sharedOpenNewTab = (page, params) => {
    try {
        // Open the new page in a new tab
        const newWindow = window.open(page, '_blank');

        // Wait until the new page is fully loaded, then send the data
        newWindow.onload = () => {
            console.log('onload');
            newWindow.postMessage(params, window.location.origin);
        };
    } catch (err) {
        console.log('sharedNextPage error:', err);
    }
};

export async function exportarLink(urlDescarga, nombreArchivo) {
    try {

        const link = document.createElement('a');
        link.href = urlDescarga;
        link.target = '_blank';
        link.setAttribute(
            'download',
            nombreArchivo,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        //      });
    } catch (err) {
        console.log('exportarLink err');
        console.log(err);
    }
}

export const sharedMensajeConfirmacion = (message, data) => {
    try {
        return message + ': ' + data;
    } catch (err) {
        return message;
    }
};